import { api } from "@/lib/api";

const LS_FLAG = "signalagent_push_ever_enabled";

export function isPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export function getPermission() {
  if (!isPushSupported()) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function getVapidPublicKey() {
  const { data } = await api.get("/push/vapid-public-key");
  return data.publicKey;
}

export async function subscribePush() {
  if (!isPushSupported()) throw new Error("Push non supporté par ce navigateur.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") {
    localStorage.setItem(LS_FLAG, "denied");
    throw new Error(
      perm === "denied"
        ? "Permission refusée. Activez les notifications dans les réglages du navigateur."
        : "Permission non accordée."
    );
  }
  const reg = await navigator.serviceWorker.ready;
  const vapid = await getVapidPublicKey();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(vapid),
    });
  }
  const json = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: json.endpoint,
    keys: json.keys,
    expirationTime: json.expirationTime || null,
  });
  localStorage.setItem(LS_FLAG, "granted");
  return sub;
}

export async function unsubscribePush() {
  if (!isPushSupported()) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) await sub.unsubscribe();
  } catch (_e) {
    /* ignore */
  }
  try {
    await api.post("/push/unsubscribe");
  } catch (_e) {
    /* ignore */
  }
  localStorage.removeItem(LS_FLAG);
}

export async function ensurePushSubscriptionIfGranted() {
  // Called on app load: if permission already granted, make sure the server has our subscription.
  if (!isPushSupported()) return;
  if (Notification.permission !== "granted") return;
  try {
    await subscribePush();
  } catch (_e) {
    /* silent */
  }
}

export function hasEverEnabled() {
  return localStorage.getItem(LS_FLAG) === "granted";
}
